module.exports = __webpack_public_path__ + "static/media/google-play.e4cb19ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/google-play.svg
// module id = 558
// module chunks = 0